export const RouteNames = {
  landingPage: "/",
  login: "/login",
  register: "/register",
  createAccount: "/create-account",
  createTicket: "/create-ticket",
  verifyMail: "/verifymail",
  resetPassword: "/resetPassword",
  reportIssue: "/ReportIssue",
  ticketDetails: "/TicketDetails",
  dashboard: "/Dashboard",
  addNewTradesman: "/AddNewTradesperson",
  viewAllTradesman: "/ViewAllTradesperson",
  addNewListing: "/AddNewProperty",
  viewAllListings: "/ViewAllProperties",
  viewListingDetails: "/ViewAllProperties",
  viewTradespersonDetails: "/viewTradespersonDetails",
  addNewAnnouncement: "/AddNewAnnouncement",
  viewAllAnnouncements: "/ViewAllAnnouncements",
  viewAllTAnnouncements: "/ViewAllTAnnouncements",
  allTickets: "/AllTickets",
  feedback: "/Feedback",
  rejectJob: "/JobStatus",
  JobCompletion: "/JobCompletion",
  jobStatus: "/TicketStatus",
  complaince: "/Compliance",
  test: "/test",
  settings: "/Settings/AccountSettings",
  customization: "/Settings/AccountCustomization",
  myDetails: "/Settings/MyDetails",
  support: "/support",
  messages: "/MyMessages",
  accountDetails: "/AccountDetails",
  subscription: "/Subscription",
  adminUsers: "/AdminUsers",
  adminAdd: "/AdminAdd",
  tags: "/tags",
  addTag: "/addTag",
  propertyOwners: "/propertyOwners",
  addPropertyOwner: "/addPropertyOwner",
  adminView: "/viewAdminDetails",
  loginPasswordChange: "/passwordChange",
  checklist: "/checklist",
  createTicketExpiredLink: "/create-ticket-expired-link",
  createTicketSuccess: "/create-ticket-success",
  paymentSuccess: "/payment-success",
  paymentFailure: "/payment-failure",
  jobAssignment: "/JobAssignment",
  quoteApproval: "/quotes",
  quoteSubmission: "/quote",
  shortLink: "/l",
  hub: "/MyHub",
  sharedFile: "/shared-file",
};
